var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCassiopeiaBadgeFacebook = function SvgCassiopeiaBadgeFacebook(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.858,
    height: 50,
    viewBox: "0 0 10.546 13.229",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.047 40.848a141.49 141.49 0 0 0-132.852 98.068l176.282 176.282a141.49 141.49 0 0 0 98.051-132.852 141.49 141.49 0 0 0-141.48-141.498Z",
    style: {
      fill: "#4267b2",
      fillOpacity: 1,
      stroke: "#1c3566",
      strokeWidth: 7.09923,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 12.0803,
      strokeOpacity: 1
    },
    transform: "matrix(.03727 0 0 .03727 -.48 -.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.948 44.35a139.484 139.003 0 0 0-130.964 96.348l99.866 99.51a172.57 171.975 0 0 0 94.646-150.974 172.57 171.975 0 0 0-3.158-30.854 139.484 139.003 0 0 0-60.39-14.03Z",
    style: {
      mixBlendMode: "soft-light",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 6.98653,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 12.0803,
      strokeOpacity: 1
    },
    transform: "matrix(.03727 0 0 .03727 -.48 -.02)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.182 9.364h-5.736l.863-4.155.027-.29c0-.374-.154-.719-.4-.964L13.973 3 7.99 8.99a1.778 1.778 0 0 0-.536 1.283v9.09c0 1 .818 1.819 1.818 1.819h8.181c.755 0 1.4-.455 1.673-1.11l2.746-6.408c.081-.21.127-.428.127-.664v-1.818c0-1-.818-1.818-1.818-1.818zM5.636 10.273H2v10.909h3.636z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    },
    transform: "scale(.30206) rotate(45 6.546 25.528)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.464 315.196a141.49 141.49 0 0 0 8.646-43.413c.004-78.15-63.35-141.502-141.498-141.498a141.49 141.49 0 0 0-43.43 8.629z",
    style: {
      fill: "#ebeff7",
      fillOpacity: 1,
      stroke: "#1c3566",
      strokeWidth: 7.09923,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 12.0803,
      strokeOpacity: 1
    },
    transform: "matrix(.03727 0 0 .03727 -.48 -.02)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCassiopeiaBadgeFacebook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cassiopeia-badge-facebook.b2c82a1546cc1f20b2ac9f672bf334a0.svg";